import { render } from "./textEditor.vue?vue&type=template&id=b842c554&scoped=true"
import script from "./textEditor.vue?vue&type=script&lang=js"
export * from "./textEditor.vue?vue&type=script&lang=js"

import "./textEditor.vue?vue&type=style&index=0&id=b842c554&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b842c554"]])

export default __exports__